import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import EntityStatus from "go-list/core/components/Table/components/EntityStatus";
import { OrganizationAlert } from "../../../../../../services/Api/Organization/organizationTypes";
import OrganizationAlertItem from "../OrganizationAlertItem";

interface Props {
	isShown: boolean;
	onHide: () => void;
	alerts: OrganizationAlert[];
}

const OrganizationAlertsModal = ({ isShown, onHide, alerts }: Props) => {
	const { t } = useTranslation("admin");
	const alertsStatus = alerts.find((alert) => alert.type === "DANGER") ? "DISABLED" : "WARNING";

	return (
		<Modal show={isShown} onHide={onHide} className="alerts-modal">
			<Modal.Header closeButton>
				<Modal.Title>
					{t("modules.organization.field.alerts.title")}
					<EntityStatus status={alertsStatus} />
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{alerts.map((alert, index) => (
					<OrganizationAlertItem alert={alert} key={`organization-alerts-modal-${index}`} />
				))}
			</Modal.Body>
		</Modal>
	);
};
export default OrganizationAlertsModal;
